import React from 'react';
import { Outlet } from 'react-router-dom';


export const SettingsIndex = () => {
    return (
        <div className='flex flex-col flex-1'>
            <Outlet />
        </div>)
}